import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";

import Info from "../Info";
import { useContent } from "../../content/useContent";

type IProps = {
  handleClick: any;
  row: any;
};

const classes = {
  between: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
  },
  category: {
    fontWeight: "bold",
  },
};

const ListItem: React.FC<IProps> = ({ handleClick, row }) => {
  const { pages } = useContent();
  const { games } = pages;
  return (
    <Card>
      <CardActionArea onClick={() => handleClick(row.id)}>
        <CardContent sx={{ pt: 1, pr: 1 }}>
          {/* <Box sx={classes.between}> */}
          {/* <Typography
                variant="h5"
                component="h5"
                color="primary"
                sx={classes.title}
              >
                {row.id}
              </Typography> */}

          {/* </Box> */}

          <Box sx={classes.between}>
            <Typography
              variant="h5"
              component="h5"
              color="primary"
              sx={classes.title}
            >
              <Info title={games.animal} description={row.model} />
            </Typography>
          </Box>

          {/* <Box sx={classes.between}>
              <Typography
                variant="h6"
                component="h6"
                color="primary"
                sx={classes.title}
              >
                {row.id}
              </Typography>
            </Box> */}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ListItem;
